import Model from 'flarum/common/Model';
import computed from 'flarum/common/utils/computed';
import { getPlainContent } from 'flarum/common/utils/string';
export default class DialogMessage extends Model {
  number() {
    return Model.attribute('number').call(this);
  }
  content() {
    return Model.attribute('content').call(this);
  }
  contentHtml() {
    return Model.attribute('contentHtml').call(this);
  }
  renderFailed() {
    return Model.attribute('renderFailed').call(this);
  }
  contentPlain() {
    return computed('contentHtml', content => {
      if (typeof content === 'string') {
        return getPlainContent(content);
      }
      return content;
    }).call(this);
  }
  createdAt() {
    return Model.attribute('createdAt', Model.transformDate).call(this);
  }
  dialog() {
    return Model.hasOne('dialog').call(this);
  }
  user() {
    return Model.hasOne('user').call(this);
  }
  canDelete() {
    return Model.attribute('canDelete').call(this);
  }
}
flarum.reg.add('flarum-messages', 'common/models/DialogMessage', DialogMessage);